//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

const template = `
<div class="nav3-panel-subsection">
    <p ng-if="$ctrl.text" class="cu-text-subsection-2" ng-bind="$ctrl.text"></p>
    <ng-transclude></ng-transclude>
</div>
`;

angular.module('curalate').component('nav3Subsection', {
  bindings: {
    text: '@?',
  },
  template,
  transclude: true,
});
